module.exports = __webpack_public_path__ + "static/media/mr.449b2d35.png";